import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@material-ui/icons/Close";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";

import { REPORT_CONFIG, SEARCH_BY } from "./reportConfig";
import { useReportIframe } from "./useReportIframe";
import ReportFilters from "./ReportFilters";
import styleSheet from "../styleSheet";

const ReportsModal = ({ open, onClose }) => {
  const reportsList = Object.entries(REPORT_CONFIG).map(([key, r]) => ({
    key,
    label: r.label,
  }));
  const [report, setReport] = useState("");
  const [searchByValue, setSearchByValue] = useState("");
  const [search, setSearch] = useState("");
  const [iframeURL, setIframeURL] = useState("");
  const [isFullscreen, setIsFullscreen] = useState(false);

  const { buildIframeURL, triggerDownload } = useReportIframe({
    search,
    searchByValue,
  });

  const reset = () => {
    const firstReport = reportsList[0]?.key || "";
    const defaultSearch = "";
    const defaultSearchBy = SEARCH_BY[0]?.value || "";

    setReport(firstReport);
    setSearch(defaultSearch);
    setSearchByValue(defaultSearchBy);
    setIframeURL("");
    setIsFullscreen(false);

    handleReportChange(firstReport, defaultSearch, defaultSearchBy);
  };

  const handleReportChange = async (key, searchVal, searchByVal) => {
    setReport(key);

    const url = await buildIframeURL(
      REPORT_CONFIG[key].path,
      searchVal,
      searchByVal,
    );

    setIframeURL(url);
  };

  useEffect(() => {
    if (!open) {
      reset();
    }
  }, [open]);

  useEffect(() => {
    if (reportsList.length && !report) {
      setReport(reportsList[0].key);
    }
  }, [reportsList]);

  useEffect(() => {
    if (report) {
      const defaultSearchBy = SEARCH_BY[0]?.value || "";
      setSearchByValue(defaultSearchBy);

      handleReportChange(report, "", defaultSearchBy);
    }
  }, [report]);

  return (
    <Dialog
      open={open}
      onClose={(_, r) => r !== "backdropClick" && onClose()}
      fullWidth
      maxWidth="lg"
      fullScreen={isFullscreen}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between">
          Operations Report
          <Box>
            <IconButton onClick={() => setIsFullscreen(!isFullscreen)}>
              {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </IconButton>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent
        sx={{ backgroundColor: "#f2f2f2", flex: "unset", padding: 0 }}
        style={{
          padding: isFullscreen ? 16 : 24,
        }}
      >
        <ReportFilters
          report={report}
          reports={reportsList}
          searchBy={SEARCH_BY}
          searchByValue={searchByValue}
          search={search}
          onReportChange={(key) => {
            setReport(key);
          }}
          onSearchByChange={setSearchByValue}
          onSearchChange={setSearch}
          onSearch={() => handleReportChange(report, search, searchByValue)}
          onDownload={triggerDownload}
          onReset={reset}
          disableDownload={!iframeURL}
          downloadSx={
            !iframeURL ? styleSheet.FabIconsDisable : styleSheet.colorblue
          }
          resetSx={styleSheet.colorblue}
          searchSx={!search ? styleSheet.FabIconsDisable : styleSheet.colorblue}
        />
      </DialogContent>
      <Box>
        <iframe
          id="report-iframe"
          src={iframeURL}
          title="Report"
          style={{ width: "100%", height: 350, border: "none" }}
        />
      </Box>
    </Dialog>
  );
};

export default ReportsModal;
